import React from 'react';

export const Services_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>SERVICIOS DE PRODUCCIÓN</span>,
  },
];

export const Travel_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>TRAVEL & LIVING</span>,
  },
];

export const Locations_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>LOCACIONES</span>,
  },
];

export const Casting_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>CASTING</span>,
  },
];

export const Permits_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>PERMISOLOGÍA</span>,
  },
];

export const Rent_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>GESTIÓN DE RENTA DE EQUIPO</span>,
  },
];

export const Crew_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>CREW MULTILINGÜE</span>,
  },
];

export const Insurance_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>SEGUROS</span>,
  },
];

export const All_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    textMobile: '1.5rem',
    renderContent: () => <span>SERVICIOS EN TODA LA REPÚBLICA MEXICANA</span>,
  },
];
